// extracted by mini-css-extract-plugin
export default {"main":"DefaultLayout_main__sDg3z"};